<template>
  <div>
    <view-user
      :auths="authsSelectedUser"
      customComponent="Tasks"
      :user-id="selectedUserId"
      v-model="viewUserDialog"
      @getUsers="getPendingTasks" />

    <v-card class="elevation-0">
      <v-col cols="12" class="grey--text pa-4">
        <v-row align="center" class="ml-1">
          {{$t('general.pendingTasks')}}
        </v-row>
      </v-col>
      <v-divider></v-divider>
      <v-card-text class="pa-0">
        <div class="overflow-y-auto" style="max-height: 400px">
          <v-list v-if="tasksNotifications.length === 0">
            <v-list-item>
              <v-list-item-avatar>
                <v-icon>check</v-icon>
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-subtitle>
                  {{$t('general.noPendingTasks')}}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>

          <v-list two-line class="pa-0">
            <template v-for="task in tasksNotifications.slice(0,25)">
              <PendingTask :key="task.id"
                           :color="tasksNotifications.state"
                           :pendingTask="task" @showUser="showUser"/>
            </template>
          </v-list>
        </div>
        <v-divider></v-divider>
        <v-toolbar dense>
          <v-btn color="primary"
                 block text class="ma-0"
                 @click="goToHomeTasks">{{$t('general.seeAll')}}</v-btn>
        </v-toolbar>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import PendingTask from '@/components/widgets/list/PendingTask.vue'
import ViewUser from '@/pages/App/People/dialogs/ViewUser/ViewUser.vue'

export default {
  components: { PendingTask, ViewUser },
  computed: {
    ...mapGetters(
      ['tasksNotifications']
    )
  },
  data () {
    return {
      authsSelectedUser: [],
      selectedUserId: '',
      selectedUsers: [],
      viewUserDialog: false
    }
  },
  mounted () {
    this.getPendingTasks()
  },
  methods: {
    showUser (user) {
      this.selectedUserId = user.UUID || user.userId
      this.authsSelectedUser = user.auths
      this.viewUserDialog = true
    },
    async goToHomeTasks () {
      this.$router.push('/Home', () => {})
      this.$vuetify.goTo(850)
    },
    async getPendingTasks () {
      await this.$store.dispatch('getTasksNotifications')
    }
  }
}
</script>
